import { getFirstFlashAlert } from './apiFeedback';
import { globalUserMessageDataKey } from './constants';

export const dispatchFlashAlert = (dispatchEvent, errorOrResponse) => {
  if (window.isSSR || typeof dispatchEvent !== 'function') {
    return null;
  }

  const flashAlert = getFirstFlashAlert(errorOrResponse);

  if (!flashAlert) {
    return null;
  }

  dispatchEvent({
    type: globalUserMessageDataKey.globalUserMessage,
    detail: {
      allowHtml: true,
      defaultMessage: flashAlert.message,
    },
  });

  return flashAlert;
};

export default dispatchFlashAlert;
